/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit DropdownOption.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import "DesignSystem/Fonts/WonderUnitSans-400.js"
import CheckSelected from 'DesignSystem/Svgs/CheckSelected/view.js'
import Info from 'DesignSystem/Info/view.js'
import React from 'react'
import useIsHovered from 'Logic/useIsHovered.js'
import useIsMedia from 'Logic/useIsMedia.js'
import { css } from "emotion"

let styles = {}
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
  height: 'var(--height)',
position: 'var(--position)',
top: 'var(--top)',
width: 'var(--width)',
left: 'var(--left)'})
styles.Horizontal1 = css({label: 'Horizontal1',
  flexDirection: "row",
width: "100%",
marginTop: 4,
borderBottomLeftRadius: 4,
borderBottomRightRadius: 4,
borderTopLeftRadius: 4,
borderTopRightRadius: 4,
cursor: "pointer",
justifyContent: "space-between",
paddingRight: 16,
alignItems: "center",
userSelect: "none",
  
transition: 'background-color 150ms ease-in-out',
willChange: 'background-color',
  backgroundColor: 'var(--backgroundColor)'})
styles.Text = css({label: 'Text',
  fontSize: 14,
fontFamily: "WonderUnitSans",
paddingBottom: 4,
paddingLeft: 16,
paddingRight: 8,
paddingTop: 4,
lineHeight: 1.6,
textOverflow: "ellipsis",
overflowX: "hidden",
flexGrow: 1,
flexShrink: 1,
flexBasis: "auto",
  
transition: 'color 150ms ease-in-out',
willChange: 'color',
  color: 'var(--color)',
whiteSpace: 'var(--whiteSpace)'})
styles.Vertical = css({label: 'Vertical',
  backgroundColor: "rgba(255,127,0,0.1)",
backdropFilter: "blur(10px)",
position: "absolute",
right: 50,
top: 10,
height: 20,
paddingLeft: 8,
paddingRight: 8,
justifyContent: "center",
alignItems: "center",
borderBottomLeftRadius: 4,
borderBottomRightRadius: 4,
borderTopLeftRadius: 4,
borderTopRightRadius: 4,
  
transition: 'transform 150ms ease-in-out',
willChange: 'transform',
  transform: 'translateX(var(--translateX))'})

export default function DropdownOption({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  height= 40,
position= "absolute",
top= 0,
width= "100%",
left= 0,
disabled,
onlyForHoverFixMeInTheMorpherThanks,
onClick,
isSelected,
text= "Option",
banner
}) {
    
    let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isSelected})
    let isMedia = useIsMedia()
    
    
    

  return (<React.Fragment
>
<div
 data-testid="DropdownOption.Horizontal"
 data-view-path={dataViewPath}
 style={{'--height': typeof height === 'number' ? `${height}px` : height,'--position': position,'--top': typeof top === 'number' ? `${top}px` : top,'--width': typeof width === 'number' ? `${width}px` : width,'--left': typeof left === 'number' ? `${left}px` : left}}
 className={`views-block ${styles.Horizontal}`}
>
<button
 data-testid="DropdownOption.Horizontal:1"
 data-view-path={dataViewPath}
 disabled={disabled}
 {...isHoveredBind}
 onClick={onlyForHoverFixMeInTheMorpherThanks}
 onMouseDown={onClick}
 style={{'--backgroundColor': isSelected ? "rgba(0,207,104, 0.1)" : isHovered ? "rgba(0,207,104, 0.15)" : "#ffffff"}}
 className={`views-block ${styles.Horizontal1}`}
>
<span
 data-testid="DropdownOption.Text"
 data-view-path={dataViewPath}
 style={{'--color': isSelected ? "rgb(0,188,112)" : "#606060",'--whiteSpace': isMedia.mobile ? "wrap" : "nowrap"}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
<CheckSelected
 data-testid="DropdownOption.CheckSelected"
 data-view-path={dataViewPath}
 opacity={isSelected ? 1 : 0}
/>
{
banner ? 
<div
 data-testid="DropdownOption.Vertical"
 data-view-path={dataViewPath}
 style={{'--translateX': isHovered ? "230px" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<Info
 data-testid="DropdownOption.Info"
 data-view-path={dataViewPath}
 text={banner}
 fontSize={12}
 color="rgba(255,127,0,1)"
 marginTop={1}
 fontWeight={600}
/>
</div>
 : null
}
</button>
</div>
{children}
</React.Fragment>)
}